import { ReactiveVar, makeVar } from '@apollo/client'

import { IMessage } from 'shared/interfaces'

export const MessagesStore = {
  message: {
    read: () => messageVar()
  }
}

export const messageVar: ReactiveVar<IMessage> = makeVar<any>({})
